<form [formGroup]="form" (ngSubmit)="save(form.value)">
    <mat-card-content class="ph125">
        <mat-form-field class="full-width">
            <input
                matInput
                placeholder="{{
                    'settings.user_settings.fields.name' | translate
                }}"
                formControlName="name"
            />
        </mat-form-field>

        <mat-form-field class="full-width" floatPlaceholder="always">
            <textarea
                matInput
                placeholder="{{
                    'settings.user_settings.fields.contact_info' | translate
                }}"
                formControlName="contactInfo"
            ></textarea>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-select
                placeholder="{{
                    'settings.user_settings.fields.language' | translate
                }}"
                formControlName="language"
            >
                <mat-option
                    *ngFor="let language of supportedLanguages"
                    [value]="language.locale"
                >
                    {{ language.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div layout="row" class="form-field-row">
            <mat-form-field>
                <mat-select
                    placeholder="{{
                        'settings.user_settings.fields.currency' | translate
                    }}"
                    formControlName="currency"
                >
                    <mat-option
                        [value]="code"
                        *ngFor="let code of objectKeys(currencies)"
                        >{{ currencies[code].name }} ({{
                            currencies[code].symbol
                        }})</mat-option
                    >
                </mat-select>
            </mat-form-field>

            <mat-form-field>
                <mat-select
                    placeholder="{{
                        'settings.user_settings.fields.numbering_system'
                            | translate
                    }}"
                    formControlName="numberingSystem"
                >
                    <mat-option value="fdi">FDI</mat-option>
                    <mat-option value="universal"
                        >Universal (American)</mat-option
                    >
                </mat-select>
            </mat-form-field>
        </div>

        <div class="flex mt-2">
            <div class="w-1/2 pr-2">
                {{ "settings.user_settings.fields.logo" | translate }}

                <file-drop
                    [customstyle]="'my-drop-zone'"
                    (onFileDrop)="dropped($event)"
                    (click)="fileInput.click()"
                >
                    <div [hidden]="logoUrl">
                        <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                        {{ "settings.user_settings.upload_logo" | translate }}
                    </div>
                    <img [src]="logoUrl" *ngIf="logoUrl" />
                </file-drop>

                <input
                    id="input-logo"
                    type="file"
                    accept="image/*"
                    #fileInput
                    [hidden]="true"
                    (change)="uploadLogo()"
                />
            </div>
            <div class="w-1/2 pl-2">
                {{ "settings.user_settings.fields.color" | translate }}
                <div class="mt-2">
                    <app-color-selector
                        [colors]="[
                            '#FBB040',
                            '#8DC63F',
                            '#3EA8C9',
                            '#EF4136',
                            '#9E1F63',
                            '#662D91',
                            '#2B3990',
                            '#726658',
                            '#A7A9AC',
                            '#414042'
                        ]"
                        [selected]="defaultColor"
                        [pickerPosition]="'left'"
                        (change)="defaultColor = $event"
                    ></app-color-selector>
                </div>
            </div>
        </div>
    </mat-card-content>

    <mat-card-actions align="end" class="mh125 mv125">
        <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="!form.valid"
            class="uppercase"
        >
            {{ "save" | translate }}
        </button>
    </mat-card-actions>
</form>



// WEBPACK FOOTER //
// /app/src/app/settings/components/user-settings/user-settings.component.html